<template>
  <v-card :loading="loading">
    <v-card-text class="pa-2 caption black--text">
      <v-simple-table dense>
        <template v-slot:default>
          <thead>
            <tr>
              <th v-for="header in headers" :key="header.text" :class="header.class">
                {{ header.text }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in tableItems"
              :key="item.category + item.value"
              @click="setExpanded(index)"
            >
              <td
                v-for="header in headers"
                :key="header.text + item.category + item.value"
                :class="header.class"
              >
                {{ item[header.value] ? item[header.value] + header.postfix : '' }}
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data () {
    return {
      loading: false,
      expanded: [],
      headers: [
        { text: 'Element', class: 'text-left', value: 'category', postfix: '' },
        { text: 'Most popular', class: 'text-left', value: 'value', postfix: '' },
        { text: 'Percentage', class: 'text-left', value: 'percentage', postfix: '%' }
      ],
      items: [],
    }
  },
  watch: {
    async '$route.params' () {
      await this.getData()
    }
  },
  async mounted () {
    await this.getData()
  },
  computed: {
    tableItems () {
      if (this.expanded.length) {
        return this.items.reduce((all, item, index) => {
          all.push({ ...item })
          if (this.expanded.includes(index)) {
            all[all.length - 1].value = null
            all[all.length - 1].percentage = null
            all = all.concat(item.items.sort((a, b) => b.percentage - a.percentage))
          }
          return all
        }, [])
      } else {
        return this.items
      }
    }
  },
  methods: {
    setExpanded (index) {
      if (this.expanded.includes(index)) {
        this.expanded.splice(this.expanded.indexOf(index), 1)
      } else {
        this.expanded.push(index)
      }
    },
    async getData () {
      this.loading = true
      const { data } = await this.$axios.get(
        `${this.$store.getters.projectPath}/marketing/telemetry/global-info/pc-configurations`, {
          params: {
            build_tag: this.$route.params.buildTag
          }
        }
      ).catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.items = data
      }
      this.loading = false
    }
  }
}
</script>